import { gameGroups } from '@infinitro/catalog-ex';
import { GameCategory } from '@infinitro/catalog-min';
import { FeatureSet, ReleaseStage, stateUi, Theme, wantAtLeastReleaseStage } from '@infinitro/config';
import { t, Verbiage } from '@infinitro/content';
import { CasinoIcon, TabIcons } from '@infinitro/icons';
import { derived } from 'svelte/store';
export const getGameTabs = (theme, locale, loggedIn, stateFeatureSet) => {
    return derived([locale, loggedIn, stateFeatureSet, t, gameGroups, stateUi], ([$locale, $loggedIn, $stateFeatureSet, $t, $gameGroups, $stateUi], set, update) => {
        const showGameGroups = $stateFeatureSet === FeatureSet.Preview &&
            wantAtLeastReleaseStage(ReleaseStage.Alpha) &&
            $stateUi.casinoLobby.showGameGroups === true;
        const groupTabs = showGameGroups
            ? ($gameGroups['casino'] ?? []).map((group) => ({
                label: group.name,
                value: group.groupSlug,
                icon: group.iconUrl ?? undefined,
                link: true,
                url: `/game-group/${group.groupSlug}/`,
                minWidthPx: 130
            }))
            : [];
        const data = [
            {
                label: $t(Verbiage.lobby),
                value: GameCategory.All,
                icon: CasinoIcon,
                remoteIcon: 'LobbyIcon',
                link: true,
                url: '/casino/'
            },
            {
                label: $t(Verbiage.popular),
                value: GameCategory.Popular,
                icon: TabIcons.PopularIcon,
                remoteIcon: 'PopularIcon',
                link: true,
                url: '/populargames/'
            },
            {
                label: $t(Verbiage.originals),
                value: GameCategory.Originals,
                icon: TabIcons.OriginalsIcon,
                remoteIcon: 'OriginalsIcon',
                link: true,
                url: '/originals/'
            },
            {
                label: $t(Verbiage.slots),
                value: GameCategory.Slots,
                icon: TabIcons.SlotsIcon,
                remoteIcon: 'SlotsIcon',
                link: true,
                url: '/slots/'
            },
            {
                label: $t(Verbiage.live_casino),
                value: GameCategory.LiveCasino,
                icon: TabIcons.LiveCasinoIcon,
                remoteIcon: 'LiveCasinoIcon',
                link: true,
                url: '/livecasino/'
            },
            {
                label: $t(Verbiage.new_games),
                value: GameCategory.NewGames,
                icon: TabIcons.NewGamesIcon,
                remoteIcon: 'NewGamesIcon',
                link: true,
                url: '/newgames/'
            },
            {
                label: $t(Verbiage.game_shows),
                value: GameCategory.GameShows,
                icon: TabIcons.GameShowsIcon,
                remoteIcon: 'GameShowsIcon',
                link: true,
                url: '/gameshows/'
            },
            {
                label: $t(Verbiage.feature_buy_in),
                value: GameCategory.FeatureBuyIn,
                icon: TabIcons.FeatureBuyInIcon,
                remoteIcon: 'FeatureBuyInIcon',
                link: true,
                url: '/featurebuyin/'
            },
            {
                label: $t(Verbiage.recently_played),
                value: GameCategory.RecentlyPlayed,
                icon: TabIcons.RecentlyIcon,
                remoteIcon: 'RecentlyPlayedIcon',
                link: true,
                url: '/recentlyplayed/'
            },
            {
                label: $t(Verbiage.favorites),
                value: GameCategory.Favorites,
                icon: TabIcons.FavoritesIcon,
                remoteIcon: 'FavoritesIcon',
                link: true,
                url: '/favorites/',
                authed: true
            },
            ...groupTabs
        ].filter((item) => (!item.rel || item.rel === $stateFeatureSet) &&
            (!item?.authed || $loggedIn === true) &&
            (!item.stage || wantAtLeastReleaseStage(item.stage)));
        set(data);
    }, []);
};
